import {
  useDeleteFarmGateInternalStorageData,
  useGetFarmGateInternalStorageById,
  usePostFarmGateInternalStorageData,
  usePutFarmGateInternalStorageData
} from "../../../../../api/cultivations";
import {
  useDeleteProcessGateInternalStorageData,
  useGetProcessGateInternalStorageById,
  usePostProcessGateInternalStorageData,
  usePutProcessGateInternalStorageData
} from "../../../../../api/process";
import {
  useDeleteSimulationFarmGateInternalStorageData,
  useGetExistingFarmGateInternalStorageById,
  useGetSimulationFarmGateInternalStorageById,
  usePostSimulationFarmGateInternalStorageData,
  usePutSimulationFarmGateInternalStorageData
} from "../../../../../api/simulation/simulationFGInternalStorage";
import {
  useDeleteSimulationProcessGateInternalStorageData,
  useGetSimulationProcessGateInternalStorageById,
  usePostSimulationProcessGateInternalStorageData,
  usePutSimulationProcessGateInternalStorageData
} from "../../../../../api/simulation/processGateInternalStorage";
import {
  useDeleteFarmGateInternalStorageData as useDeleteSupplierFarmGateInternalStorageData,
  useGetFarmGateInternalStorageById as useGetSupplierFarmGateInternalStorageById,
  usePostFarmGateInternalStorageData as usePostSupplierFarmGateInternalStorageData,
  usePutFarmGateInternalStorageData as usePutSupplierFarmGateInternalStorageData
} from "../../../../../api/supplierFarmGate";
import {
  useDeleteProcessGateInternalStorageData as useDeleteSupplierProcessGateInternalStorageData,
  useGetProcessGateInternalStorageById as useGetSupplierProcessGateInternalStorageById,
  usePostProcessGateInternalStorageData as usePostSupplierProcessGateInternalStorageData,
  usePutProcessGateInternalStorageData as usePutSupplierProcessGateInternalStorageData
} from "../../../../../api/supplierProcessGate";
import { InternalStorageGate, InternalStorageToolVariant } from "./internalStorage.types";

type InternalStorageApiHookSet = {
  useGetById: (id: any) => {
    data: any;
    status?: string;
    fetchStatus?: string;
    isLoading?: boolean;
    refetch?: () => Promise<any>;
  };
  useCreate: () => { mutate: (...args: any[]) => void; isLoading?: boolean };
  useUpdate: () => { mutate: (...args: any[]) => void; isLoading?: boolean };
  useDelete: () => { mutate: (...args: any[]) => void; isLoading?: boolean };
  useGetOriginalById: (id: any) => { data: any; isLoading?: boolean; refetch?: () => Promise<any> };
};

const noopOriginalHook = () => ({ data: undefined, isLoading: false });

export const INTERNAL_STORAGE_API_HOOKS: Record<
  InternalStorageGate,
  Record<InternalStorageToolVariant, InternalStorageApiHookSet>
> = {
  farm: {
    mapping: {
      useGetById: useGetFarmGateInternalStorageById,
      useCreate: usePostFarmGateInternalStorageData,
      useUpdate: usePutFarmGateInternalStorageData,
      useDelete: useDeleteFarmGateInternalStorageData,
      useGetOriginalById: noopOriginalHook
    },
    simulate: {
      useGetById: useGetSimulationFarmGateInternalStorageById,
      useCreate: usePostSimulationFarmGateInternalStorageData,
      useUpdate: usePutSimulationFarmGateInternalStorageData,
      useDelete: useDeleteSimulationFarmGateInternalStorageData,
      useGetOriginalById: useGetExistingFarmGateInternalStorageById
    },
    supplier: {
      useGetById: useGetSupplierFarmGateInternalStorageById,
      useCreate: usePostSupplierFarmGateInternalStorageData,
      useUpdate: usePutSupplierFarmGateInternalStorageData,
      useDelete: useDeleteSupplierFarmGateInternalStorageData,
      useGetOriginalById: noopOriginalHook
    }
  },
  process: {
    mapping: {
      useGetById: useGetProcessGateInternalStorageById,
      useCreate: usePostProcessGateInternalStorageData,
      useUpdate: usePutProcessGateInternalStorageData,
      useDelete: useDeleteProcessGateInternalStorageData,
      useGetOriginalById: noopOriginalHook
    },
    simulate: {
      useGetById: useGetSimulationProcessGateInternalStorageById,
      useCreate: usePostSimulationProcessGateInternalStorageData,
      useUpdate: usePutSimulationProcessGateInternalStorageData,
      useDelete: useDeleteSimulationProcessGateInternalStorageData,
      useGetOriginalById: useGetProcessGateInternalStorageById
    },
    supplier: {
      useGetById: useGetSupplierProcessGateInternalStorageById,
      useCreate: usePostSupplierProcessGateInternalStorageData,
      useUpdate: usePutSupplierProcessGateInternalStorageData,
      useDelete: useDeleteSupplierProcessGateInternalStorageData,
      useGetOriginalById: noopOriginalHook
    }
  }
};

export const getInternalStorageApiHooks = (
  gate: InternalStorageGate,
  variant: InternalStorageToolVariant
): InternalStorageApiHookSet => INTERNAL_STORAGE_API_HOOKS[gate][variant];
